import React, { Component } from 'react';
import { Loading } from '../common/LoadingComponent';
import { Fade, Stagger } from 'react-animation-components';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Package, MapPin, Flag, Plus } from '../../icons';

function DeliveryCard({ delivery }) {
    const dep  = (delivery.departure  || '').split('--');
    const dest = (delivery.destination || '').split('--');
    const dateStr = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: '2-digit', month: 'short' })
        .format(delivery.dateDeparture);

    return (
        <Link to={`/mydeliveries/${delivery.id}`} className="trip-card">
            <div className="trip-card__inner">
                <div className="trip-card__top">
                    <span className="trip-card__date">
                        <Package size={14} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 5 }} />
                        {dateStr}
                    </span>
                    <span className="trip-card__price">{delivery.price} €</span>
                </div>
                <div className="trip-card__route">
                    <div className="trip-card__from">
                        <MapPin size={14} strokeWidth={2} color="var(--primary)" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                        {dep[0] || '—'}
                    </div>
                    <div className="trip-card__to">
                        <Flag size={14} strokeWidth={2} color="var(--gray)" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                        {dest[0] || '—'}
                    </div>
                </div>
            </div>
        </Link>
    );
}

class MyDeliveries extends Component {
    render() {
        const { myDeliveries } = this.props;

        if (myDeliveries.isLoadingMyDeliveries) return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;
        if (myDeliveries.errMess)               return <div className="container text-center" style={{ padding: '80px 0' }}><p style={{ color: 'var(--gray)' }}>{myDeliveries.errMess}</p></div>;

        if (!Array.isArray(myDeliveries.myDeliveries) || !myDeliveries.myDeliveries.length) {
            return (
                <div className="list-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-6">
                                <div className="empty-state">
                                    <div className="empty-state__icon"><Package size={48} strokeWidth={1.2} color="var(--border)" /></div>
                                    <h3 className="empty-state__title">Aucun envoi pour le moment</h3>
                                    <p className="empty-state__text">Publiez votre première demande et trouvez un voyageur pour transporter votre colis.</p>
                                    <Link to="/adddelivery">
                                        <Button color="primary" style={{ borderRadius: 50, padding: '13px 28px', fontWeight: 700 }}>
                                            Envoyer un colis
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="list-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="list-page__header">
                                <h1 className="list-page__title">Mes envois</h1>
                                <Link to="/adddelivery">
                                    <Button color="primary" size="sm" style={{ borderRadius: 50, fontWeight: 700, padding: '8px 18px', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        <Plus size={15} strokeWidth={2.5} /> Ajouter
                                    </Button>
                                </Link>
                            </div>
                            <Stagger in>
                                {myDeliveries.myDeliveries.map(delivery => (
                                    <Fade in key={delivery.id}><DeliveryCard delivery={delivery} /></Fade>
                                ))}
                            </Stagger>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MyDeliveries;
